(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enquiry-logo-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.enquiry-tabs-section').forEach(section => {
    const wrapper = section.querySelector('.form-tabs');
    if (!wrapper) return;

    const titleEl = section.querySelector('.form-title');
    const descEl  = section.querySelector('.form-description');
    const tabs    = section.querySelectorAll('.enquiry-tab');
    const panels  = section.querySelectorAll('.form-panel');

    const content = {
      enquiry: { title: wrapper.dataset.enquiryTitle || '', desc: wrapper.dataset.enquiryDesc || '' },
      logo:    { title: wrapper.dataset.logoTitle || '',    desc: wrapper.dataset.logoDesc || '' }
    };

    function activate(type) {
      tabs.forEach(t => t.classList.toggle('is-active', t.dataset.tab === type));
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.form === type));
      if (titleEl) titleEl.textContent = content[type].title;
      if (descEl)  descEl.textContent  = content[type].desc;
    }

    activate('enquiry');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => activate(tab.dataset.tab));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function updateGiftboxTrigger(group) {
    const checked = group.querySelector('.giftbox-option-row__input:checked');
    const valueHolder = group.querySelector('[data-giftbox-value]');

    if (!checked || !valueHolder) return;

    valueHolder.textContent = checked.dataset.title || checked.value || '';
  }

  function updateMainProductImage(input) {
    if (!input) return;

    const newImage = input.dataset.image;
    if (!newImage) return;

    const mainImage = document.querySelector('.product__media img');

    if (mainImage) {
      mainImage.src = newImage;
      mainImage.srcset = newImage;
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-giftbox-trigger]');
    if (!trigger) return;

    const group = trigger.closest('[data-giftbox-group]');
    if (!group) return;

    const panel = group.querySelector('[data-giftbox-panel]');
    const isOpen = group.classList.contains('is-open');

    document.querySelectorAll('[data-giftbox-group]').forEach((item) => {
      item.classList.remove('is-open');

      const itemTrigger = item.querySelector('[data-giftbox-trigger]');
      const itemPanel = item.querySelector('[data-giftbox-panel]');

      if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
      if (itemPanel) itemPanel.hidden = true;
    });

    if (!isOpen) {
      group.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.giftbox-option-row__input');
    if (!input) return;

    const group = input.closest('[data-giftbox-group]');
    if (!group) return;

    group.classList.remove('has-error');

    const configurator = group.closest('.giftbox-configurator');
    const optionsError = configurator ? configurator.querySelector('[data-error-for="giftbox-options"]') : null;

    const allGroups = configurator ? configurator.querySelectorAll('[data-giftbox-group]') : [];
    let allValid = true;
    allGroups.forEach((g) => {
      if (!g.querySelector('.giftbox-option-row__input:checked')) allValid = false;
    });
    if (allValid && optionsError) optionsError.style.display = 'none';

    const panel = group.querySelector('[data-giftbox-panel]');
    const trigger = group.querySelector('[data-giftbox-trigger]');

    updateGiftboxTrigger(group);
    updateMainProductImage(input);

    group.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-giftbox-group]').forEach((group) => {
      updateGiftboxTrigger(group);

      const checked = group.querySelector('.giftbox-option-row__input:checked');
      if (checked) {
        updateMainProductImage(checked);
      }
    });

    document.querySelectorAll('.product__gift-message-input[data-required-property]').forEach((textarea) => {
      textarea.addEventListener('input', function () {
        textarea.classList.remove('field-error-input');
        const msgError = textarea.parentElement.querySelector('[data-error-for="message"]');
        if (msgError) msgError.style.display = 'none';
      });
    });

    document.querySelectorAll('[data-box-colour-input]').forEach((input) => {
      input.addEventListener('change', function () {
        const field = input.closest('[data-box-colour-field]');
        if (field) field.classList.remove('has-error');
        const colourError = document.querySelector('[data-error-for="box-colour"]');
        if (colourError) colourError.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tabs-faq').forEach(section => {
    const tabs = section.querySelectorAll('.faq-tab');
    const groups = section.querySelectorAll('.faq-group');
    const label = section.querySelector('.faq-current-label');

    /* -----------------------
       TAB SWITCHING + LABEL
    ----------------------- */
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const target = this.dataset.tab;
        const title = this.dataset.title;

        // Update active tab
        tabs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');

        // Switch accordion groups
        groups.forEach(group => {
          const isActive = group.dataset.tab === target;
          group.classList.toggle('is-active', isActive);

          // Reset accordions when tab changes
          if (!isActive) {
            group.querySelectorAll('.faq-question').forEach(q => q.classList.remove('open'));
            group.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
          }
        });

        // Update passive H3 label
        if (label && title) {
          label.textContent = title;
        }
      });
    });

    /* -----------------------
       ACCORDION (ONE OPEN ONLY)
    ----------------------- */
    section.querySelectorAll('.faq-question').forEach(btn => {
      btn.addEventListener('click', function () {
        const group = this.closest('.faq-group');
        const answer = this.nextElementSibling;
        const isOpen = this.classList.contains('open');

        if (!group || !answer) return;

        // Close all in this group
        group.querySelectorAll('.faq-question').forEach(q => q.classList.remove('open'));
        group.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));

        // Re-open clicked if it was closed
        if (!isOpen) {
          this.classList.add('open');
          answer.classList.add('open');
        }
      });
    });

  });
});

  } catch(e) { console.error(e); }
})();
})();
